export const extractField = (form, term) => {
  const field = form.find(o => o.id === term);
  return field;
};
